import { render } from "./HomeStudioTools.vue?vue&type=template&id=ca0538de&scoped=true&ts=true"
import script from "./HomeStudioTools.vue?vue&type=script&lang=ts"
export * from "./HomeStudioTools.vue?vue&type=script&lang=ts"

import "./HomeStudioTools.vue?vue&type=style&index=0&id=ca0538de&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca0538de"]])

export default __exports__